/* eslint-disable import/no-named-as-default */
import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import FunnelLarge from "../../Charts/FunnelLarge";
import Wrapper from "../styles/pipeline-styles";
import TimeScaleDropDown from "./TimeScaleDropDown";
import pipelineTypes from "../types/pipelineTypes";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { ChartTitle } from "../styles/employer-analytics-styles";

interface IPipelineProps {
  pipeline: {
    positions: number;
    applications: number;
    interviews: number;
    offers: number;
    placements: number;
  };
  pipelineWidgetLoader: boolean;
  pdfExport?: boolean;
}

interface IPipelineState {
  timescaleDropdownActive: boolean;
  activeTimescale: {
    id: number;
    name: string;
  };
}

export class Pipeline extends Component<IPipelineProps, IPipelineState> {
  static propTypes = {
    pipeline: pipelineTypes,
    pipelineWidgetLoader: PropTypes.bool,
  };

  static defaultProps = {
    pipeline: {
      positions: 0,
      applications: 0,
      interviews: 0,
      offers: 0,
      placements: 0,
    },
    pipelineWidgetLoader: false,
  };

  state = {
    timescaleDropdownActive: false,
    activeTimescale: {
      id: 0,
      name: "All Time",
    },
  };

  toggleDropdown = (): void => {
    this.setState(({ timescaleDropdownActive }) => ({
      timescaleDropdownActive: !timescaleDropdownActive,
    }));
  };

  selectTimescale = (timescale: { id: number; name: string }): void => {
    this.setState({
      activeTimescale: timescale,
    });
  };

  render(): ReactNode {
    const { pipeline, pipelineWidgetLoader, pdfExport } = this.props;
    const { timescaleDropdownActive, activeTimescale } = this.state;

    const pipelineData = [
      {
        id: 1,
        label: "Jobs",
        value: pipeline.positions,
        color: "rgb(0, 143, 251)",
      },
      {
        id: 2,
        label: "Applications",
        value: pipeline.applications,
        color: "rgb(0, 227, 150)",
        // percentage: {
        //   tooltip: 'Interview rate',
        //   value:
        //     pipeline.applications === 0
        //       ? 0
        //       : Math.round((pipeline.interviews / pipeline.applications) * 100),
        // },
      },
      {
        id: 3,
        label: "Interviews",
        value: pipeline.interviews,
        color: "rgb(254, 176, 25)",
        // percentage: {
        //   tooltip: 'Offer rate',
        //   value:
        //     pipeline.interviews === 0
        //       ? 0
        //       : Math.round((pipeline.offers / pipeline.interviews) * 100),
        // },
      },
      {
        id: 4,
        label: "Offers",
        value: pipeline.offers,
        color: "rgb(255, 69, 96)",
        // percentage: {
        //   tooltip: 'Placement rate',
        //   value:
        //     pipeline.offers === 0
        //       ? 0
        //       : Math.round((pipeline.placements / pipeline.offers) * 100),
        // },
      },
      {
        id: 5,
        label: "Placements",
        value: pipeline.placements,
        color: "rgb(119, 93, 208)",
      },
    ];

    const timescaleOptions = [
      { id: 0, name: "All Time" },
      { id: 7, name: "Last 7 days" },
      { id: 30, name: "Last 30 days" },
      { id: 90, name: "Last 90 days" },
    ];

    return (
      <Wrapper
        className="animated fadeIn delay-2"
        pdfExport={pdfExport}
        id="pipeline-widget"
      >
        <AnalyticsWidgetLoading
          text="Updating..."
          active={pipelineWidgetLoader}
        />
        <ChartTitle
          marginBottom={20}
          data-test-id="pipeline-chart-title"
          pdfExport={pdfExport}
        >
          Pipeline
          {!pdfExport && (
            <TimeScaleDropDown
              toggleDropdown={this.toggleDropdown}
              dropdownActive={timescaleDropdownActive}
              selectTimescale={this.selectTimescale}
              activeTimescale={activeTimescale}
              options={timescaleOptions}
              type="PIPELINE"
              testId="pipeline-chart-timescale-dropdown"
            />
          )}
        </ChartTitle>
        <FunnelLarge
          bordered
          data={pipelineData}
          tooltips
          dataTestId="pipeline-chart"
        />
      </Wrapper>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    chartsData: {
      pipeline: unknown;
    };
    pipelineWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  pipeline: state.employerAnalytics.chartsData.pipeline,
  pipelineWidgetLoader: state.employerAnalytics.pipelineWidgetLoader,
});

export default connect(mapStateToProps, {})(Pipeline);
